import React, { useState, useMemo } from "react";
import AttendanceDetailsSlidingPanel from "../SelfService/MyAttendance/AttendanceDetailsSlidingPanel";
import statusColor from "../../../utils/Attendance/statusColor";
import attendaceStatus from "../../../utils/Attendance/attendanceStatus";
import { extractClockInOutTimes } from "../../../utils/Attendance/extractClockInOutTimes";
import { LEAVE_MODES } from "../../../redux/constants/actvityType";
import { generateDateRange } from "../../../utils/FormatDate/generateDates";

 const FULLORMULTIPLELEAVEMODE = LEAVE_MODES.FULL_OR_MULTIPLE_LEAVE_MODE;

const MyAttendanceListData = ({
  fromDate,
  toDate,
  attendanceData = [],
  isProcessAttendance,
}) => {
  const [
    isAttendanceDetailsSlidingPanelOpen,
    setAttendanceDetailsSlidingPanelOpen,
  ] = useState(false);
  const [selectedAttendanceData, setSelectedAttendanceData] = useState(null);

  const handleOpenAttendanceDetailsSlidingPanel = (record) => {
    setSelectedAttendanceData(record);
    setAttendanceDetailsSlidingPanelOpen(true);
  };

 const handleCloseAttendanceDetailsSlidingPanel = () => {
  setAttendanceDetailsSlidingPanelOpen(false);
  setSelectedAttendanceData(null);
};

 


  const dataMap = useMemo(() => {
    const map = {};
    attendanceData.forEach((item) => {
      map[item.attendanceDate] = item;
    });
    return map;
  }, [attendanceData]);

  const dateRange = generateDateRange(fromDate, toDate);

  return (
    <>
      <AttendanceDetailsSlidingPanel
        open={isAttendanceDetailsSlidingPanelOpen}
        close={handleCloseAttendanceDetailsSlidingPanel}
        isProcessAttendance={selectedAttendanceData}
      />

      {dateRange.map((date) => {
        const formattedDate = date.format("YYYY-MM-DD");
        const displayDate = date.format("DD-MM-YYYY (ddd)");
        const record = dataMap[formattedDate];

        const shiftDuration = record?.shiftDuration || "-";
        const statusLabel =
          attendaceStatus.find(
            (status) => status.value === record?.attendance_status_id
          )?.label || "-";

        const {
          firstClockIn = "-",
          lastClockOut = "-",
          durationMinutes = 0,
          remainingHours = "-",
        } = record
          ? extractClockInOutTimes(record.activity, record.shiftDuration)
          : {};

        const totalWorkedHours = Math.round(durationMinutes / 60);

        const fullDayLeave = record?.getEmployeeLeave?.find(
          (l) => Number(l.leave_mode_id) === FULLORMULTIPLELEAVEMODE
        );

        const isLeave = record?.isEmployeeLeave && fullDayLeave;
        const hasAttendance = firstClockIn !== "-" && lastClockOut !== "-";

        return (
          <tr
            key={formattedDate}
            className="bg-white border-b hover:bg-gray-50 dark:hover:bg-gray-200"
          >
            <td
              className="px-10 py-4 font-medium text-gray-800 whitespace-nowrap cursor-pointer hover:text-blue-600"
              onClick={
                record
                  ? () => handleOpenAttendanceDetailsSlidingPanel(record)
                  : undefined
              }
            >
              {displayDate}
            </td>

            {isLeave ? (
              <>
                <td className="px-10 py-4">-</td>
                <td className="px-10 py-4">-</td>
                <td className="px-10 py-4">
                  {fullDayLeave?.duration_in_day || "-"} day
                </td>
                <td className="px-10 py-4">
                  {shiftDuration !== "-" ? `${shiftDuration} Hrs` : "-"}
                </td>

                <td className="px-10 py-4">
                  Leave: {fullDayLeave?.leave_name || "-"}
                </td>
              </>
            ) : (
              <>
                <td className="px-10 py-4">{firstClockIn}</td>
                <td className="px-10 py-4">{lastClockOut}</td>
                <td
                  className="px-10 py-4"
                  style={{
                    color:
                      record && hasAttendance
                        ? statusColor(shiftDuration, totalWorkedHours)
                        : "inherit",
                  }}
                >
                  {remainingHours !== "-" ? `${remainingHours} Hrs` : "-"}
                </td>
                <td className="px-10 py-4">
                  {shiftDuration !== "-" ? `${shiftDuration} Hrs` : "-"}
                </td>

                <td className="px-10 py-4">
                  {hasAttendance ? (
                    <>
                      <span
                        style={{
                          backgroundColor:
                            statusColor(shiftDuration) === "red"
                              ? "lightcoral"
                              : "lightgreen",
                          borderRadius: "50%",
                          width: "10px",
                          height: "10px",
                          display: "inline-block",
                          marginRight: "5px",
                        }}
                      ></span>
                      <span>{statusLabel}</span>
                    </>
                  ) : (
                    "-"
                  )}
                </td>
              </>
            )}
          </tr>
        );
      })}
    </>
  );
};

export default MyAttendanceListData;
